<template lang="pug">
  .b-base-textarea
    ._label(v-if="labelOuter && label") {{ label }}
    textarea.__field(
      :placeholder="labelOuter ? '' : label"
      :class="{ error: !!error }"
      :data-testid="inputTestId"
      v-on="inputListeners"
      ) {{ value }}
    ._error-text(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'BaseTextarea',
  props: {
    value: String,
    type: String,
    label: String,
    error: String,
    // подпись над полем вместо плейсхолдера — как у BaseInput; BaseField
    // отдаёт этот проп всем типам полей формы
    labelOuter: Boolean,
    /**
     * Тестовая метка на самом поле ввода: обёртка компонента — div, а сценариям нужно попадать в
     * элемент ввода (ТЗ 12.8). Тот же приём и то же имя проп, что у BaseInput.
     */
    inputTestId: String,
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.base-textarea {
  // те же значения, что у одноимённой подписи BaseInput: поля формы должны
  // выглядеть одинаково независимо от типа
  &__label {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #92A0B0;
    margin-bottom: 8px;
  }

  &__field {
    display: block;
    width: 100%;
    min-height: 130px;
    padding: 12px 16px;
    resize: none;
    box-sizing: border-box;
    font-size: 13px;
    border-radius: 6px;
    background-color: var(--color-super-light);
    color: var(--color-dark-gray);
    outline: 0;
    font-weight: 500;

    &.error {
      border: 1px solid!important;
      color: var(--color-red)!important;
      margin-bottom: 4px!important;
    }

    &::placeholder {
      font-size: 13px;
      opacity: 1;
      font-weight: 500;
      color: var(--color-middle-gray);
    }
  }

  &__error-text {
    //max-width: 286px;
    text-align: left;
    color: var(--color-red)!important;
    letter-spacing: .01em;
    font-weight: 500;
    line-height: 13px;
    font-size: 10px;
    padding: 0 16px;
  }
}
</style>
